export const urlHasPrefix = (url: string) => {
  const matches = url.match(
    /^(\/(?:gb|us|ca|de|be|es|fr)\/(?:en|fr|nl|de|es))\/?/
  );
  const rawUrl = url.replace(matches?.[1] || "", "");
  return { matches, rawUrl };
};
